import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { TranslatePipe } from "@ngx-translate/core";
import { UtilModule } from "../util/util.module";
import { AdministracionEncuestasComponent } from "./administracion-encuestas/administracion-encuestas.component";
import { EncuestaSatisfaccionComponent } from "./encuesta-satisfaccion/encuesta-satisfaccion.component";
import { PreguntasComponent } from './preguntas/preguntas.component';

@NgModule({
  declarations: [
    AdministracionEncuestasComponent,
    EncuestaSatisfaccionComponent,
    PreguntasComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, UtilModule, TranslatePipe],
  exports: [
    AdministracionEncuestasComponent,
    EncuestaSatisfaccionComponent,
    PreguntasComponent
  ],
})
export class EncuestasModule {}